import Footer from "../components/FooterComponents/Footer";
import SEO from "../components/SEO";
import { seoConfig } from "../data/seoConfig";
import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({
    user: "Rk Infosys",
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhone = (phone) =>
    /^\d{10}$/.test(phone);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim())
      newErrors.email = "Email is required";
    else if (!validateEmail(formData.email))
      newErrors.email = "Invalid email address";

    if (!formData.phone.trim())
      newErrors.phone = "Phone is required";
    else if (!validatePhone(formData.phone))
      newErrors.phone = "Invalid phone number";

    if (!formData.message.trim())
      newErrors.message = "Message is required";
    else if (formData.message.length < 10)
      newErrors.message = "Minimum 10 characters required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handlePhoneChange = (e) => {
    const phone = e.target.value.replace(/\D/g, "").slice(0, 10);
    setFormData({ ...formData, phone });
    setErrors({ ...errors, phone: "" });
  };
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    if (!validateForm()) {
      toast.error("Please Fill the Form Correctly");
      setSubmitLoading(false); //  important
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/send-mail-inquiry`,
        formData,
        {
          headers: {
            "x-license-key": "1234567890",
            "Content-Type": "application/json",
          },
        }
      );

      console.log(res.data);

      if (res.status === 200) {
        toast.success("Email sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        toast.error("Something went wrong. Try again!");
      }
    } catch (err) {
      console.error("Axios error:", err.response?.data || err.message);
      toast.error("Server error. Email not sent.");
    } finally {
      setSubmitLoading(false); // always turn off loader
    }
  };


  return (
    <>
      <SEO {...seoConfig.contact} />
      <div id="contact" className=" bg-white pt-mb-0">
        <div className="container contact-section bg-white">
          <h1 className="text-center fw-bold mb-5">
            Contact Us
          </h1>
          <h5 className="text-center mb-5">Engage with a team of specialists ready to support your vision through insight-driven collaboration and tailored solutions.</h5>
          <Toaster position="top-right" />

          <div className="row align-items-center bg-white py-6 rounded shadow-lg p-5">
            {/* FORM */}
            <div className="col-lg-6 mb-4">
              <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label">Name *</label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control ${errors.name && "is-invalid"}`}
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <div className="invalid-feedback">{errors.name}</div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    name="email"
                    className={`form-control ${errors.email && "is-invalid"}`}
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <div className="invalid-feedback">{errors.email}</div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone *</label>
                  <input
                    type="tel"
                    name="phone"
                    className={`form-control ${errors.phone && "is-invalid"}`}
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    maxLength={10}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                  <div className="invalid-feedback">{errors.phone}</div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Message *</label>
                  <textarea
                    rows="5"
                    name="message"
                    className={`form-control ${errors.message && "is-invalid"}`}
                    value={formData.message}
                    onChange={handleChange}
                  />
                  <div className="invalid-feedback">{errors.message}</div>
                </div>

                <button
                  className="btn btn-light shadow-lg border-0 px-4"
                  style={{ backgroundColor: "#0FC4A5", color: "white" }}
                  disabled={submitLoading}
                >
                  {submitLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Sending...
                    </>
                  ) : (
                    "Send Message"
                  )}
                </button>
              </form>
            </div>

            {/* IMAGE */}
            <div className="col-lg-6 p-0 d-none d-lg-block">
              <img
                src="/assets/images/hero/contact.jpg"
                alt="Contact"
                className=" rounded"
                height="100%"
                width="100%"
                loading="lazy"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
        </div>

        <div className="container-fluid mt-4 bg-white">
          <h2 className="text-center mb-3 text-primary_color">Our Location</h2>
          <div>
            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3726.4040314870435!2d72.94214347502886!3d20.936283780690065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0f7aac40948d3%3A0xd3d135a71957d869!2sRachana%20Residency!5e0!3m2!1sen!2sin!4v1770963097614!5m2!1sen!2sin"
              width="100%"
              height="450"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"></iframe> */}
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.233284322989!2d72.9450821!3d20.9372003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0f70d55a7b10d%3A0x6b2be1847689db8b!2sRK%20Infosys!5e1!3m2!1sen!2sin!4v1780565123962!5m2!1sen!2sin"
               className="responsive-map"
               allowFullScreen
               loading="lazy"
               referrerPolicy="no-referrer-when-downgrade"
               title="RK Infosys location map"></iframe> 
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Contact;